module.exports = __webpack_public_path__ + "static/media/icon_game_archero@2x.db148c26.png";